import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var LoadingThread = function () {
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "sp-circle" }) }));
};
